import { supabase } from './supabaseClient';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/** Returns the user's UI language ('en' or 'fr') from localStorage,
 *  matching the i18n provider in lib/i18n.js. Defaults to 'fr'. */
function uiLang() {
  try {
    const v = window.localStorage.getItem('lang');
    return v === 'en' ? 'en' : 'fr';
  } catch {
    return 'fr';
  }
}

async function authHeaders() {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  const base = token ? { Authorization: `Bearer ${token}` } : {};
  try {
    const ts = window.localStorage.getItem('sp.iapPurchased.v1');
    if (ts) {
      const age = Date.now() - Number(ts);
      if (age >= 0 && age <= 30 * 60 * 1000) {
        base['X-IAP-Recent'] = String(ts);
      }
    }
  } catch { /* localStorage disabled */ }
  return base;
}

async function call(path, opts = {}) {
  const headers = {
    'Content-Type': 'application/json',
    'Accept-Language': uiLang(),
    ...(await authHeaders()),
    ...(opts.headers || {}),
  };
  const res = await fetch(`${BACKEND}/api${path}`, { ...opts, headers });
  if (!res.ok) {
    let detail = res.statusText;
    try {
      const j = await res.json();
      detail = j.detail || detail;
    } catch (e) {
      // Response body wasn't JSON; keep the HTTP statusText as the user-facing message.
      if (process.env.NODE_ENV === 'development') console.debug('[billingApi] non-JSON error body', e);
    }
    throw new Error(detail);
  }
  return res.json();
}

export const billingApi = {
  config: () => call('/billing/config'),
  status: () => call('/billing/status'),
  createCheckout: (plan) =>
    call('/billing/create-checkout-session', {
      method: 'POST',
      body: JSON.stringify({ plan, origin: window.location.origin }),
    }),
  openPortal: () =>
    call('/billing/create-portal-session', {
      method: 'POST',
      body: JSON.stringify({ origin: window.location.origin }),
    }),
  checkoutStatus: (sessionId) => call(`/billing/checkout-status/${sessionId}`),
};
